import { useAdmin } from '../context/Admins/AdminContext';
import AdminNameTitle from '../features/admin/setting/components/AdminNameTitle';
import { AdminSideBar } from "../features/admin/setting/components/AdminSideBar";

export default function AdminDashPage({ children }) {
    const { profile } = useAdmin();

    if (!profile) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    // if (loading) return <div className="text-center my-4 text-danger">هناك مشكلة تواصل مع الدعم</div>;

    return (
        <div className='container dashboard col-12 position-relative d-flex ps-0'>
            <AdminSideBar superAdminRole={profile?.data?.role} />
            <div className='container mt-4 col-10'>
                <AdminNameTitle
                    adminName={profile?.data?.firstName}
                    role={profile?.data?.role}
                />
                {children}
            </div>
        </div>
    )
};